import React, { useState, useEffect } from 'react';
import { Card, Input, Button, Space, Typography, List, Tag } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SamplerNode = ({ node, onNodeChange }) => {
  const [seeds, setSeeds] = useState([]);
  const [newSeed, setNewSeed] = useState('');
  
  // 初始化种子值
  useEffect(() => {
    if (node && node.inputs) {
      const currentSeed = node.inputs.seed;
      
      // 如果是数组，直接使用；否则创建单元素数组
      const seedsArray = Array.isArray(currentSeed) 
        ? [...currentSeed] 
        : currentSeed 
          ? [currentSeed] 
          : [];
      
      setSeeds(seedsArray);
    }
  }, [node]);
  
  // 验证输入是否为有效的数字
  const isValidNumber = (value) => {
    return /^[0-9]+$/.test(value);
  };
  
  // 处理新种子输入
  const handleNewSeedChange = (e) => {
    const value = e.target.value;
    if (value === '' || isValidNumber(value)) {
      setNewSeed(value);
    }
  };
  
  // 添加新种子
  const handleAddSeed = () => {
    if (newSeed && isValidNumber(newSeed)) {
      const seedValue = parseInt(newSeed, 10);
      const updatedSeeds = [...seeds, seedValue];
      
      setSeeds(updatedSeeds);
      setNewSeed('');
      
      // 通知父组件种子变更
      onNodeChange(node.nodeId, {
        seed: updatedSeeds
      });
    }
  };
  
  // 删除种子
  const handleDeleteSeed = (index) => {
    const updatedSeeds = [...seeds];
    updatedSeeds.splice(index, 1);
    
    setSeeds(updatedSeeds);
    
    // 如果删除后只有一个种子，恢复为数字而非数组
    if (updatedSeeds.length === 1) {
      onNodeChange(node.nodeId, {
        seed: updatedSeeds[0]
      });
    } else {
      onNodeChange(node.nodeId, {
        seed: updatedSeeds
      });
    }
  };
  
  // 生成随机种子
  const handleGenerateRandomSeed = () => {
    const randomSeed = Math.floor(Math.random() * 1000000000000000);
    setNewSeed(randomSeed.toString());
  };
  
  return (
    <Card 
      title={`采样器节点 (ID: ${node.nodeId})`}
      style={{ marginBottom: 16 }}
    >
      <div>
        <Text>采样器: {node.inputs.sampler_name || '未指定'}</Text>
        {node.inputs.scheduler && <Text>, 调度器: {node.inputs.scheduler}</Text>}
        {node.inputs.steps && <Text>, 步骤: {node.inputs.steps}</Text>}
      </div>
      
      <div style={{ marginTop: 16, marginBottom: 16 }}>
        <Text strong>随机数种子:</Text>
        <List
          size="small"
          bordered
          dataSource={seeds}
          renderItem={(seed, index) => (
            <List.Item
              actions={[
                <Button 
                  type="text" 
                  danger 
                  icon={<DeleteOutlined />} 
                  onClick={() => handleDeleteSeed(index)}
                />
              ]}
            >
              <Tag color="blue">{seed}</Tag>
            </List.Item>
          )}
          style={{ marginTop: 8, marginBottom: 16 }}
        />
        
        <Space style={{ marginTop: 8 }}>
          <Input
            placeholder="输入新的种子值"
            value={newSeed}
            onChange={handleNewSeedChange}
            style={{ width: 200 }}
          />
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            onClick={handleAddSeed}
            disabled={!newSeed || !isValidNumber(newSeed)}
          >
            添加
          </Button>
          <Button onClick={handleGenerateRandomSeed}>
            生成随机种子
          </Button>
        </Space>
      </div>
    </Card>
  );
};

export default SamplerNode; 